import TwinIcon from '../../../../../../baseComponents/TwinIcon'
import { dictIcon } from '../../../../../../utils/icons'

interface CashReghisterMoneyLogBoxTPVProps {
    icon: string,
    name: string,
}

const CashReghisterMoneyLogNameBoxTPV: React.FC<CashReghisterMoneyLogBoxTPVProps> = ({ icon, name }) => {
    return (
        <div className='flex flex-auto items-center'>
            <TwinIcon icon={dictIcon[icon || 'faMoneyBill']} className='mr-8 regular20 flex w-24 h-24 text-gray-63' />
            <span className='regular16'>
                {name}
            </span>
        </div>
    )
}

export default CashReghisterMoneyLogNameBoxTPV